import React, { memo } from 'react';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ContentCopy from '@mui/icons-material/ContentCopy';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';

interface JobActionsMenuProps {
  anchorEl: HTMLElement | null;
  jobId: string | null;
  onClose: () => void;
  onView: (id: string) => void;
  onCopyId: (id: string) => void;
  onDelete: (id: string) => void;
}

/** One menu instance for the whole table, anchored to whichever row's button opened it. */
const JobActionsMenu: React.FC<JobActionsMenuProps> = ({ anchorEl, jobId, onClose, onView, onCopyId, onDelete }) => {
  const run = (action: (id: string) => void) => () => {
    onClose();
    if (jobId) action(jobId);
  };
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl && jobId)}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{ sx: { minWidth: 188, borderRadius: 3 } }}
    >
      <MenuItem onClick={run(onView)}>
        <ListItemIcon>
          <VisibilityOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText>View details</ListItemText>
      </MenuItem>
      <MenuItem onClick={run(onCopyId)}>
        <ListItemIcon>
          <ContentCopy fontSize="small" />
        </ListItemIcon>
        <ListItemText>Copy job ID</ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem onClick={run(onDelete)} sx={{ color: 'error.main' }}>
        <ListItemIcon sx={{ color: 'error.main' }}>
          <DeleteOutline fontSize="small" />
        </ListItemIcon>
        <ListItemText>Delete job</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default memo(JobActionsMenu);
